<template>
  <v-overlay
      absolute
      :value="isOverlay"
  />
</template>

<script>
export default {
  name: "OverlayAbsolute",
  props: {
    isOverlay: {
      type: Boolean,
      default: ()=> {
        return false;
      }
    }
  }

}
</script>

<style scoped>

</style>